"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-two/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type FooterSection436sItem = {
    key: Key | null | undefined;
    /** Detected variants: "col-xl-4 col-lg-3 col-md-6" | "col-lg-2 col-md-6" | "col-xl-2 col-lg-3 col-md-6" | "col-lg-4 col-md-6" */
    className: string;
    footerWidgetItems?: FooterSectionContactInfosItem[];
    socialIconItems?: FooterSectionUlsItem[];
    footerMenuItems?: FooterSectionUls2Item[];
};

type FooterSectionContactInfosItem = {
    key: Key | null | undefined;
    /** Detected variants: "info@example.com" | "+1 54565 64578" */
    link0Text: ReactNode;
    /** Detected variants: "mailto:info@example.com" | "tel:5456564578" */
    href: string;
    /** Detected variants: "General Inquiries" | "Call us on" */
    span0Text: ReactNode;
    /** Detected variants: "contact-info" */
    className?: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "FB" | "TW" | "LN" | "YT" */
    link0Text: ReactNode;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Clinics" | "Hospitals" | "Specialities" | "Contact Us" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.clinics" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.contactUs" */
    href: string;
};

type FooterSectionUls3Item = {
    key: Key | null | undefined;
    /** Detected variants: "Legal Notice" | "Privacy Policy" | "Refund Policy" */
    link0Text: ReactNode;
    /** Detected variants: "#" | "all_routes.privacyPolicy" */
    href: string;
};
export type HomeTwoFooterSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSection436sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "bg" */
    footerDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-06.png" */
    footerDiv0ImageWithBasePath0ImageSrc?: string;
    footerDiv0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    footerDiv0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-bg-07.png" */
    footerDiv0ImageWithBasePath1ImageSrc?: string;
    footerDiv0ImageWithBasePath1ImageVisible?: boolean;
    footerDiv0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv1Div0Div0Div0P0PText?: ReactNode;
    footerSectionUls3LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSection436s: FooterSection436sItem[];
    footerSectionUls3: FooterSectionUls3Item[];
    footerSection436sItemWrapper?: (item: FooterSection436sItem, content: ReactNode) => ReactNode;
    footerSection436sRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSection436sImageVisible?: boolean;
    footerSection436sImageRenderer?: (item: FooterSection436sItem, defaultNode: ReactNode) => ReactNode;
    footerSection436sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSection436sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerSectionContactInfosItemWrapper?: (item: FooterSectionContactInfosItem, content: ReactNode) => ReactNode;
    footerSectionContactInfosRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls2ItemWrapper?: (item: FooterSectionUls2Item, content: ReactNode) => ReactNode;
    footerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls3ItemWrapper?: (item: FooterSectionUls3Item, content: ReactNode) => ReactNode;
    footerSectionUls3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls3LinkVisible?: boolean;
    footerSectionUls3LinkRenderer?: (item: FooterSectionUls3Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls3LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls3Item) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeTwoFooterSectionGenerated: FC<HomeTwoFooterSectionGeneratedProps> = ({
    footerDiv0ImageWithBasePath0ImageAlt = "bg",
    footerDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-bg-06.png",
    footerDiv0ImageWithBasePath0ImageVisible,
    footerDiv0ImageWithBasePath0ImageRenderer,
    footerDiv0ImageWithBasePath0ImageProps,
    footerDiv0ImageWithBasePath1ImageAlt = "bg",
    footerDiv0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-bg-07.png",
    footerDiv0ImageWithBasePath1ImageVisible,
    footerDiv0ImageWithBasePath1ImageRenderer,
    footerDiv0ImageWithBasePath1ImageProps,
    footerDiv1Div0Div0Div0P0PText = "Copyright © 2026 Doccure. All Rights Reserved",
    divDiv0Div0ImageWithBasePath0ImageProps,
    footerSectionUls3LiLink0LinkProps,
    liLink0LinkProps,
    footerDiv0Div0Div0ClassName,
    footerSection436s,
    footerSectionUls3,
    footerSection436sItemWrapper,
    footerSection436sRenderer,
    footerSection436sImageVisible,
    footerSection436sImageRenderer,
    footerSection436sImageProps,
    footerSectionContactInfosItemWrapper,
    footerSectionContactInfosRenderer,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
    footerSectionUls2ItemWrapper,
    footerSectionUls2Renderer,
    footerSectionUls3ItemWrapper,
    footerSectionUls3Renderer,
    footerSectionUls3LinkVisible,
    footerSectionUls3LinkRenderer,
    footerSectionUls3LinkProps,
}) => {
    return (
        <footer className="footer-two">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-4"}>
                        {renderCollectionNode(
                            footerSection436s,
                            (item: FooterSection436sItem) => (
                                <div className={item.className} key={item.key}>
                                    <div className="footer-widget footer-about">
                                        <div className="footer-logo">
                                            {renderItemNode(footerSection436sImageVisible, footerSection436sImageRenderer, item, (
                                                <SmartImage src="/Templates/Doccure/img/logo-02.svg" alt="logo" {...(typeof footerSection436sImageProps === "function" ? footerSection436sImageProps(item) : (footerSection436sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                        <div className="footer-about-content">
                                            <p>We are a dedicated Eye Care and Vision Health Center committed to providing advanced, Diagnostic Treatments.</p>
                                            <div className="social-icon">
                                                <ul>
                                                    {renderCollectionNode(
                                                        item.socialIconItems ?? [],
                                                        (item: FooterSectionUlsItem) => (
                                                            <li key={item.key}>
                                                                {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                                    <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                                ))}
                                                            </li>
                                                        ),
                                                        footerSectionUlsItemWrapper,
                                                        footerSectionUlsRenderer
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ),
                            footerSection436sItemWrapper,
                            footerSection436sRenderer
                        )}
                    </div>
                </div>
                {renderNode(footerDiv0ImageWithBasePath0ImageVisible, footerDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath0ImageSrc} alt={footerDiv0ImageWithBasePath0ImageAlt} className="footer-bg-01" {...(footerDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(footerDiv0ImageWithBasePath1ImageVisible, footerDiv0ImageWithBasePath1ImageRenderer, (
                    <SmartImage src={footerDiv0ImageWithBasePath1ImageSrc} alt={footerDiv0ImageWithBasePath1ImageAlt} className="footer-bg-02" {...(footerDiv0ImageWithBasePath1ImageProps ?? {})} />
                ))}
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        <div className="copyright-text">
                            <p className="mb-0">{footerDiv1Div0Div0Div0P0PText}</p>
                        </div>
                        <div className="copyright-menu">
                            <ul>
                                {renderCollectionNode(
                                    footerSectionUls3,
                                    (item: FooterSectionUls3Item) => (
                                        <li key={item.key}>
                                            {renderItemNode(footerSectionUls3LinkVisible, footerSectionUls3LinkRenderer, item, (
                                                <SmartLink href={item.href} {...(typeof footerSectionUls3LinkProps === "function" ? footerSectionUls3LinkProps(item) : (footerSectionUls3LinkProps ?? {}))} {...(typeof footerSectionUls3LiLink0LinkProps === "function" ? footerSectionUls3LiLink0LinkProps(item) : (footerSectionUls3LiLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                        </li>
                                    ),
                                    footerSectionUls3ItemWrapper,
                                    footerSectionUls3Renderer
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default HomeTwoFooterSectionGenerated;
